import { BqButton, BqDialog } from '@beeq/react'
import styled from 'styled-components'

export const StyledBqDialog = styled(BqDialog)`
text-align: left;
  ::part(content) {
    gap: var(--bq-spacing-l);
  }
  & p {
    margin-bottom: 0;
    font-size: var(--bq-font-size--m);
    line-height: var(--bq-font-line-height--regular);
  }
`

export const StyledWrapper = styled.div`
  display: flex;
  gap: var(--bq-spacing-xs);
`

export const StyledTitle = styled.h5`
  font-weight: var(--bq-font-weight--bold);
  color: var(--bq-text--primary);
  display: flex;
  align-items: center;
  gap: var(--bq-spacing-xs);
  margin: 0;
`

export const StyledDialogBqButton = styled(BqButton)`
  ::part(button) {
    color: var(--bq-background--brand);
  }
  ::part(button):hover {
    color: var(--bq-text--alt);
  }
`
